<div class="modal-header">
  <h5 class="modal-title">
    <i class="bi bi-grid-3x3-gap"></i> Namensmatrix der Feinbodenformen
  </h5>
  <button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body nm-body">
  <!-- Filter-Toolbar -->
  <div class="d-flex align-items-center gap-2 mb-2 flex-wrap nm-toolbar">
    <div class="input-group input-group-sm nm-search">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control"
             placeholder="Kürzel, Lokalname, Substrat …"
             title="Filtert Zeilen nach Lokalnamen-Kürzel, vollem Lokalnamen oder Substrat-Suffix"
             [(ngModel)]="searchTerm" (ngModelChange)="recompute()">
      @if (searchTerm) {
        <button type="button" class="btn btn-outline-secondary"
                (click)="searchTerm = ''; recompute()" title="Suche zurücksetzen">
          <i class="bi bi-x"></i>
        </button>
      }
    </div>

    <select class="form-select form-select-sm nm-suffix"
            [(ngModel)]="filterSuffix" (ngModelChange)="recompute()"
            title="Auf ein Substrat-Suffix einschränken" aria-label="Substrat-Suffix">
      <option value="">Substrat: alle</option>
      @for (c of matrix.cols; track c) {
        <option [value]="c">{{ c }}</option>
      }
    </select>

    <div class="form-check form-switch m-0">
      <input class="form-check-input" type="checkbox" id="nmHideEmpty"
             [(ngModel)]="hideEmptyCols" (ngModelChange)="recompute()">
      <label class="form-check-label small" for="nmHideEmpty">Leere Spalten ausblenden</label>
    </div>

    <span class="text-muted small ms-auto">
      {{ displayRows.length }} Kürzel × {{ displayCols.length }} Substrate
    </span>
  </div>

  @if (loading) {
    <div class="text-muted">Lade Katalog …</div>
  } @else if (!matrix.rows.length) {
    <div class="alert alert-info mb-0">
      Der Bodenformenkatalog ist noch nicht befüllt.
    </div>
  } @else if (!displayRows.length || !displayCols.length) {
    <div class="alert alert-warning mb-0">
      Kein Treffer für die aktuellen Filter.
      <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="resetFilters()">
        Filter zurücksetzen
      </button>
    </div>
  } @else {
    <div class="nm-table-wrap">
      <table class="table table-sm table-bordered nm-table mb-0">
        <thead>
          <tr>
            <th class="nm-sticky-col nm-corner sortable" (click)="setSort('kuerzel')"
                title="Lokalnamen-Kürzel (erster Teil der FBF)">
              Kürzel <i class="bi {{ sortIcon('kuerzel') }}"></i>
            </th>
            <th class="nm-anzahl-col sortable text-end" (click)="setSort('anzahl')"
                title="Anzahl belegter Substrat-Varianten">
              # <i class="bi {{ sortIcon('anzahl') }}"></i>
            </th>
            @for (c of displayCols; track c) {
              <th class="nm-substrat-col sortable text-center" (click)="setSort('col:' + c)"
                  [title]="'Substrat-Suffix „' + c + '“ – klicken: Treffer nach oben'">
                {{ c }} <i class="bi {{ sortIcon('col:' + c) }} nm-col-sorticon"></i>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of displayRows; track row.kuerzel) {
            <tr>
              <th scope="row" class="nm-sticky-col nm-kuerzel"
                  [title]="row.namen.join(', ')">{{ row.kuerzel }}</th>
              <td class="nm-anzahl-col text-end text-muted">{{ row.anzahl }}</td>
              @for (c of displayCols; track c) {
                <td class="nm-cell" [class.nm-cell-hit]="row.cells.has(c)">
                  @if (row.cells.get(c); as cell) {
                    <button type="button" class="nm-hit" [class.gestrichen]="cell.gestrichen"
                            [title]="row.kuerzel + c + '  ·  ' + cell.lokalname + (cell.gestrichen ? '  (gestrichen)' : '') + '  →  Steckbrief öffnen'"
                            (click)="onCell(cell)">{{ cell.lokalname }}</button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="text-muted small mt-2">
      Schraffierte Zelle = vorhandene Feinbodenform (Kürzel + Substrat). Klick öffnet die HBF-Seite im Katalog.
      @if (matrix.duplicates.length) {
        <span class="text-warning ms-2">
          <i class="bi bi-exclamation-triangle"></i>
          {{ matrix.duplicates.length }} mehrdeutige Kombination(en) im Katalog.
        </span>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Schließen</button>
</div>
